import { render, staticRenderFns } from "./AdminGeneral.vue?vue&type=template&id=e1ef4e46&"
import script from "./AdminGeneral.vue?vue&type=script&lang=js&"
export * from "./AdminGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports